export const OutlinePhone = ({ ...props }) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.66 10.768c-.062-.062-.311-.233-.747-.513a18.547 18.547 0 00-1.446-.887c-.591-.28-.973-.404-1.144-.373a1.035 1.035 0 00-.443.187c-.125.093-.296.28-.513.56l-.327.373a3.646 3.646 0 01-.747-.28 5.745 5.745 0 01-1.61-1.143 5.745 5.745 0 01-1.143-1.61 3.648 3.648 0 01-.28-.747l.373-.327c.28-.218.467-.389.56-.513.094-.125.156-.272.187-.443.031-.172-.093-.553-.373-1.144a18.533 18.533 0 00-.887-1.446l-.513-.747a1.022 1.022 0 00-.747-.42c-.218 0-.576.249-1.073.747a12.24 12.24 0 00-1.26 1.493c-.405.56-.607.925-.607 1.097 0 .17.047.458.14.863.187.715.498 1.462.933 2.24.591 1.089 1.408 2.154 2.45 3.197 1.042 1.042 2.108 1.858 3.197 2.45.778.435 1.524.746 2.24.933.404.093.692.14.863.14.171 0 .537-.202 1.097-.607.56-.404 1.058-.824 1.493-1.26.498-.497.747-.855.747-1.073a1.022 1.022 0 00-.42-.747zM7.92 4.795c.747 0 1.377.257 1.89.77.513.513.77 1.143.77 1.89a.41.41 0 00.117.303.41.41 0 00.303.117.41.41 0 00.303-.117.41.41 0 00.117-.303c0-.653-.156-1.245-.467-1.773a3.495 3.495 0 00-1.26-1.26 3.432 3.432 0 00-1.773-.467.41.41 0 00-.303.117.41.41 0 00-.117.303.41.41 0 00.117.303.41.41 0 00.303.117zm0-2.147v-.046c.871.03 1.68.256 2.427.676a4.506 4.506 0 011.75 1.75c.42.747.645 1.556.676 2.427a.41.41 0 00.117.303.41.41 0 00.303.117.41.41 0 00.304-.117.41.41 0 00.116-.303 5.508 5.508 0 00-.77-2.847 5.778 5.778 0 00-2.076-2.076 5.507 5.507 0 00-2.847-.77.41.41 0 00-.303.116.41.41 0 00-.117.304c0 .124.039.233.117.326.077.094.178.14.303.14z"
      fill="#fff"
    />
  </svg>
);

export const DropDownIcon = ({ ...props }) => (
  <svg
    width={11}
    height={7}
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.522.814h8.032c.562 0 .844.687.437 1.094l-4 4a.641.641 0 01-.906 0l-4-4C.679 1.5.96.814 1.522.814z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRightIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.50122 8.72881C2.25958 8.7474 2.07836 8.65911 1.95754 8.46394C1.83672 8.26878 1.82743 8.06896 1.92966 7.8645C2.03189 7.66004 2.21312 7.55781 2.47334 7.55781H12.9566L11.0049 5.57826C10.8005 5.39238 10.7494 5.17863 10.8516 4.93699C10.9538 4.69536 11.135 4.57454 11.3953 4.57454C11.5626 4.57454 11.7113 4.6303 11.8414 4.74182L14.7968 7.7251C14.9269 7.83662 14.9919 7.97603 14.9919 8.14331C14.9919 8.3106 14.9269 8.45 14.7968 8.56153L13.6258 9.76041L11.8414 11.5448C11.5626 11.8236 11.2791 11.8236 10.991 11.5448C10.7029 11.266 10.7075 10.9872 11.0049 10.7084L12.9566 8.72881H2.50122Z"
      fill="currentColor"
    />
  </svg>
);

export const FacebookIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1_3203)">
      <path
        d="M15.556 18.222h3.333l1.333-5.333h-4.666v-2.667c0-1.373 0-2.666 2.666-2.666h2v-4.48c-.434-.058-2.076-.187-3.81-.187-3.62 0-6.19 2.21-6.19 6.267v3.733h-4v5.333h4v11.334h5.334V18.222z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3203">
        <rect
          x={0.666718}
          y={0.66687}
          width={26.6667}
          height={26.6667}
          rx={4}
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowUpIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="#c1282a"
    {...props}
  >
    <rect
      x={0.826567}
      y={16.183}
      width={31}
      height={31}
      rx={15.5}
      transform="rotate(-30 .827 16.183)"
      stroke="#c1282a"
    />
    <path
      d="M28.198 19.048L14.251 27.1l-.667-1.154 13.948-8.053-10.55-2.827.352-1.293 12.75 3.417-3.417 12.75-1.296-.342 2.827-10.55z"
      fill="white"
    />
  </svg>
);

export const TemporaryResidenceIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    {...props}
  >
    <path
      d="M42.527 12.71c.291.226.437.533.437.922v14.971c0 .281-.102.533-.306.755a.973.973 0 01-.744.334h-3.256l-2.369.672v.166c0 .837-.337 1.574-1.012 2.213a3.386 3.386 0 01-2.42.963c-.582 0-1.139-.138-1.668-.416-.233.5-.644.946-1.231 1.338-.583.389-1.198.583-1.844.583a3.52 3.52 0 01-1.669-.416c-.237.5-.662.945-1.275 1.338-.616.389-1.218.583-1.806.583-.583 0-1.14-.139-1.669-.416a3.819 3.819 0 01-.743.963 3.434 3.434 0 01-1.144.708c-.442.167-.838.25-1.188.25-.937 0-1.729-.305-2.375-.916L6.052 29.692H3.589a.973.973 0 01-.744-.334 1.086 1.086 0 01-.306-.755V13.632c0-.333.102-.599.306-.797a1.04 1.04 0 01.744-.292h.356l3.863 1.006c3.929-2.344 7.21-3.097 9.844-2.26 2.812-1.896 6.154-2.173 10.025-.833 4.92 2.006 8.112 3.065 9.575 3.176l4.306-1.088h.269c.291 0 .525.055.7.166zm-35.77 2.76l-2.024-.5v12.545h.706l.525-4.931.794-7.114zm26.145 16.06c.325 0 .59-.098.793-.292a.989.989 0 00.307-.75c0-.309-.088-.575-.263-.796L23.014 19.568c-2.812 2.288-5.508 2.595-8.087.922-.467-.278-.86-.724-1.182-1.338-.325-.615-.487-1.172-.487-1.672 0-.67.177-1.312.531-1.927.525-.833 1.14-1.64 1.844-2.42-1.933 0-4.131.723-6.594 2.17l-.35 2.843-1.056 9.957 10.106 7.614.094.083c.175.167.423.25.744.25.32 0 .6-.097.837-.292a.948.948 0 00.35-.755.834.834 0 00-.35-.714l-3.169-3.093c-.233-.166-.35-.416-.35-.75 0-.28.102-.519.307-.713.208-.194.472-.291.793-.291.321 0 .6.083.838.25l4.744 4.597c.233.17.495.256.787.256.296 0 .56-.1.794-.297a.931.931 0 00.35-.75c0-.305-.117-.57-.35-.797l-4.831-4.514a1.17 1.17 0 01-.27-.756c0-.277.105-.527.313-.75.204-.221.467-.332.788-.332.325 0 .604.11.837.333l4.744 4.514 1.581 1.505c.238.226.502.34.794.34.292 0 .554-.1.788-.298a.925.925 0 00.356-.75c0-.309-.119-.575-.356-.797l-6.325-6.019a1.204 1.204 0 01-.263-.755c0-.167.044-.334.131-.5a.87.87 0 01.394-.38c.175-.084.35-.126.525-.126.296 0 .56.086.794.256l6.331 6.02 1.581 1.504c.234.222.51.333.832.333zm2.593-3.177l1.844-.5-.962-12.21c-1.992-.393-5.157-1.454-9.494-3.183-3.284-1.114-6.038-.834-8.263.839 0 .055-.029.083-.087.083a13.925 13.925 0 00-2.813 3.26 1.58 1.58 0 00-.262.838c0 .5.233.918.7 1.255 2.404 1.507 5.041.308 7.912-3.598.234-.389.557-.583.97-.583.35 0 .626.111.83.333.204.222.307.474.307.755 0 .278-.088.528-.263.75a16.53 16.53 0 01-1.319 1.588L35.32 28.187l.175.166zm4.044-.838h1.231V14.97l-2.2.5.97 12.045z"
      fill="currentColor"
    />
  </svg>
);

export const PermanentResidenceIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    {...props}
  >
    <path
      d="M1.1 41.113a.948.948 0 01-.35-.755c0-.306.117-.558.35-.756.238-.194.502-.291.794-.291h1.932L.75 25.595v-.25a1.1 1.1 0 01.131-.506.838.838 0 01.394-.374c.18-.084.386-.125.62-.125H9.54a16.706 16.706 0 016.246-3.516c-.88-.5-1.7-1.209-2.463-2.129a11.12 11.12 0 01-1.801-3.051c-.442-1.119-.663-2.151-.663-3.1 0-2.676.997-4.962 2.989-6.857 1.992-1.896 4.38-2.843 7.165-2.843s5.159.947 7.122 2.843c1.967 1.895 2.951 4.181 2.951 6.858 0 1.507-.469 3.069-1.407 4.687-.938 1.618-2.111 2.815-3.52 3.592 3.226.948 5.982 2.929 8.266 5.942 2.284 3.01 3.426 6.105 3.426 9.285v3.26h1.145c.295 0 .56.097.794.291.233.198.35.464.35.797 0 .167-.044.333-.132.5a.833.833 0 01-.394.38c-.179.084-.385.125-.619.125H1.895c-.292 0-.556-.097-.794-.291zM13.15 12.545a6.96 6.96 0 001.056 3.723 7.647 7.647 0 002.858 2.718 7.886 7.886 0 003.908 1.006c2.171 0 4.032-.726 5.583-2.177 1.555-1.448 2.332-3.204 2.332-5.27 0-2.062-.777-3.833-2.332-5.312-1.55-1.475-3.412-2.212-5.583-2.212-2.168 0-4.015.737-5.54 2.212-1.522 1.48-2.282 3.25-2.282 5.312zm7.822 9.618c-1.172 0-2.518.21-4.04.63-1.525.416-2.757.932-3.695 1.547h11.167c.584 0 .936.28 1.057.838l3.164 14.133h7.034v-3.26c0-2.51-.661-4.824-1.982-6.941-1.318-2.122-3.09-3.809-5.315-5.062-2.23-1.257-4.694-1.885-7.39-1.885zm5.364 17.148l-2.901-12.878H3.301l2.814 12.878h20.22zM14.293 37.14c-1.292 0-2.378-.419-3.258-1.255-.88-.837-1.319-1.842-1.319-3.016 0-1.17.44-2.173 1.32-3.01.879-.836 1.95-1.255 3.213-1.255 1.259 0 2.328.419 3.208 1.255.88.837 1.319 1.84 1.319 3.01 0 .781-.206 1.493-.62 2.135a4.632 4.632 0 01-1.625 1.547 4.35 4.35 0 01-2.238.589zm1.538-5.817a2.227 2.227 0 00-1.582-.625c-.617 0-1.146.208-1.588.625a2.06 2.06 0 00-.656 1.546c0 .17.029.353.087.547.058.195.131.375.219.542.087.166.204.307.35.422.15.11.298.222.444.333.146.11.32.194.525.25.204.055.425.083.663.083.584 0 1.096-.208 1.538-.625.438-.42.657-.937.657-1.552a2.06 2.06 0 00-.657-1.546z"
      fill="currentColor"
    />
  </svg>
);

export const PlayBtnIcon = ({ ...props }) => (
  <svg
    width={21}
    height={24}
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.682 10.084L3.865.735C2.58-.024.612.713.612 2.591v18.692c0 1.684 1.83 2.7 3.253 1.855l15.817-9.344c1.41-.83 1.415-2.88 0-3.71z"
      fill="#fff"
    />
  </svg>
);

export const SponsorshipIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    {...props}
  >
    <path
      d="M23.718 6.525l2.456 4.764 5.45.756c.646.055.969.39.969 1.005 0 .333-.117.583-.35.75l-3.956 3.681.969 5.187v.166c0 .389-.148.696-.444.922-.175.111-.409.167-.7.167-.175 0-.321-.028-.438-.084l-4.925-2.51-4.918 2.51a1.06 1.06 0 01-.444.084c-.35 0-.627-.113-.832-.34a1.068 1.068 0 01-.312-.749v-.166l.969-5.187-3.957-3.682c-.233-.166-.35-.416-.35-.75 0-.614.323-.949.97-1.004l5.45-.756 2.456-4.764c.179-.393.502-.589.968-.589.471 0 .794.196.969.589zm2.637 9.867l2.726-2.593-3.782-.5c-.412-.055-.706-.251-.881-.588l-1.669-3.26-1.668 3.26c-.175.337-.47.533-.882.589l-3.775.5 2.719 2.592c.238.167.356.419.356.756v.166l-.618 3.593 3.343-1.755c.175-.055.35-.083.525-.083.175 0 .35.028.525.083l3.344 1.755-.619-3.593v-.166c0-.337.119-.589.357-.756zM22.75 1.838c1.642 0 3.238.238 4.788.714 1.554.472 2.946 1.154 4.175 2.046a16.019 16.019 0 013.256 3.14 14.284 14.284 0 012.194 3.973c.529 1.448.794 2.953.794 4.515 0 1.17-.236 2.453-.707 3.848a18.718 18.718 0 01-1.843 3.932c-.763 1.225-1.613 2.228-2.55 3.01v13.383a.96.96 0 01-.307.713c-.204.194-.483.292-.837.292a.974.974 0 01-.525-.167L22.749 36.3l-8.437 4.937a.974.974 0 01-.525.167c-.238 0-.444-.028-.619-.084-.35-.226-.525-.533-.525-.922V27.017c-1.408-1.17-2.61-2.816-3.606-4.937-.996-2.118-1.494-4.069-1.494-5.853 0-3.957 1.48-7.346 4.437-10.165 2.963-2.815 6.553-4.223 10.77-4.223zm.613 32.285l7.3 4.354v-9.873c-.996.614-2.271 1.116-3.825 1.505-1.554.392-2.917.588-4.088.588-1.17 0-2.533-.196-4.087-.588-1.554-.39-2.83-.89-3.825-1.505v9.873l7.3-4.354c.175-.11.379-.166.612-.166.234 0 .438.055.613.166zm-9.75-9.112c2.516 2.395 5.562 3.593 9.137 3.593s6.623-1.214 9.144-3.64c2.517-2.423 3.775-5.322 3.775-8.696 0-3.375-1.258-6.275-3.775-8.702-2.52-2.423-5.569-3.634-9.144-3.634-2.341 0-4.51.557-6.506 1.671-1.992 1.114-3.558 2.619-4.7 4.514A11.802 11.802 0 009.83 16.31c0 3.402 1.26 6.303 3.782 8.702z"
      fill="currentColor"
    />
  </svg>
);

export const FlagPolingIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={46}
    height={46}
    fill="none"
    {...props}
  >
    <path
      d="M15.34 37.14v-8.03c0-.393-.147-.7-.438-.922-1.759-1.114-3.238-2.788-4.438-5.02-1.2-2.229-1.8-4.348-1.8-6.358 0-1.67.44-3.496 1.319-5.478.879-1.98 1.962-3.526 3.25-4.64 1.17-1.059 2.737-1.965 4.7-2.718 1.962-.754 3.735-1.13 5.319-1.13 4.041 0 7.498 1.366 10.368 4.098 2.871 2.732 4.307 6.021 4.307 9.867 0 1.285-.292 2.681-.875 4.188a18.466 18.466 0 01-2.288 4.181c-.937 1.281-1.992 2.284-3.162 3.01-.292.222-.438.53-.438.922v8.03c0 .277-.119.527-.356.75a1.114 1.114 0 01-.788.332h-2.375c-.291.892-.862 1.646-1.712 2.26-.85.615-1.744.922-2.681.922-.938 0-1.832-.307-2.682-.922-.85-.614-1.42-1.368-1.712-2.26h-2.375c-.292 0-.554-.11-.788-.333-.237-.222-.356-.472-.356-.75zm5.98 1.082c.409.726 1.052 1.089 1.932 1.089.879 0 1.523-.363 1.93-1.089H21.32zm-3.693-2.17h11.25v-2.094h-11.25v2.093zm1.493-18.487l2.813 14.221h2.637l2.813-14.221-3.694 1.588a1.015 1.015 0 01-.437.083c-.175 0-.321-.027-.438-.083l-3.694-1.588zm-8.262-.756c0 1.674.527 3.458 1.581 5.354 1.054 1.9 2.286 3.323 3.694 4.27.996.666 1.494 1.559 1.494 2.677v2.677h2.018l-3.162-15.81v-.25c0-.282.102-.533.306-.755.208-.222.488-.333.838-.333a.61.61 0 01.437.166l5.188 2.26 5.187-2.26c.117-.055.263-.083.438-.083.291 0 .556.097.793.291.234.195.35.432.35.714v.25l-3.162 15.81h2.019V29.11c0-1.118.498-2.01 1.493-2.677 1.409-.947 2.64-2.37 3.694-4.27 1.054-1.896 1.581-3.68 1.581-5.354 0-3.231-1.216-6.005-3.65-8.32-2.429-2.312-5.343-3.468-8.743-3.468-3.4 0-6.315 1.156-8.744 3.467-2.433 2.316-3.65 5.09-3.65 8.322z"
      fill="currentColor"
    />
  </svg>
);

export const HorizontTowLine = ({ ...props }) => {
  return (
    <svg
      width={32}
      height={7}
      viewBox="0 0 32 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path transform="translate(.094 .225)" fill="#C1282A" d="M0 0H31V2H0z" />
      <path transform="translate(.094 4.225)" fill="#C1282A" d="M0 0H17V2H0z" />
    </svg>
  );
};

export const HorizontTwoLineLeft = ({ ...props }) => {
  return (
    <svg
      width={32}
      height={7}
      viewBox="0 0 32 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        transform="translate(14.281 4.953)"
        fill="#C1282A"
        d="M0 0H17V2H0z"
      />
      <path transform="translate(.281 .953)" fill="#C1282A" d="M0 0H31V2H0z" />
    </svg>
  );
};

export const InstagramIcon = ({ ...props }) => {
  return (
    <svg
      width={81}
      height={81}
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1_173)">
        <path
          d="M.5 40.328c0-22.091 17.909-40 40-40s40 17.909 40 40-17.909 40-40 40-40-17.909-40-40z"
          fill="#333"
        />
        <g opacity={0.9}>
          <path
            transform="translate(.5 .328)"
            fill="#000"
            fillOpacity={0.75}
            d="M0 0H80V80H0z"
          />
          <g clipPath="url(#clip1_1_173)">
            <path
              d="M40.508 32.242c-5.11 0-9.233 3.607-9.233 8.08 0 4.471 4.122 8.078 9.233 8.078 5.11 0 9.233-3.607 9.233-8.079s-4.122-8.079-9.233-8.079zm0 13.332c-3.303 0-6.003-2.356-6.003-5.253 0-2.897 2.692-5.252 6.003-5.252 3.31 0 6.003 2.355 6.003 5.252s-2.7 5.253-6.003 5.253zm11.764-13.662c0 1.047-.964 1.884-2.153 1.884-1.198 0-2.154-.844-2.154-1.884s.964-1.885 2.154-1.885c1.189 0 2.153.844 2.153 1.885zm6.115 1.912c-.136-2.524-.795-4.76-2.909-6.602-2.105-1.842-4.66-2.419-7.545-2.545-2.973-.148-11.885-.148-14.858 0-2.877.12-5.432.696-7.546 2.538-2.113 1.842-2.764 4.078-2.909 6.602-.168 2.602-.168 10.4 0 13.001.137 2.524.796 4.76 2.91 6.602 2.113 1.843 4.66 2.42 7.545 2.546 2.973.147 11.885.147 14.858 0 2.885-.12 5.44-.696 7.545-2.546 2.106-1.842 2.765-4.078 2.91-6.602.168-2.601.168-10.392 0-12.994zm-3.84 15.785c-.627 1.379-1.84 2.44-3.424 2.996-2.37.822-7.995.633-10.615.633s-8.253.182-10.615-.633c-1.575-.549-2.789-1.61-3.423-2.995-.94-2.075-.724-6.997-.724-9.289s-.209-7.22.724-9.288c.626-1.378 1.84-2.44 3.423-2.995 2.37-.823 7.995-.633 10.615-.633s8.253-.183 10.615.633c1.575.548 2.788 1.61 3.423 2.995.94 2.074.724 6.996.724 9.288s.216 7.221-.724 9.288z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1_173">
          <path
            d="M.5 40.328c0-22.091 17.909-40 40-40s40 17.909 40 40-17.909 40-40 40-40-17.909-40-40z"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="clip1_1_173">
          <path
            fill="#fff"
            transform="translate(22.5 22.328)"
            d="M0 0H36V36H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InstagramIconSecond = ({ ...props }) => {
  return (
    <svg
      className="svg-inline--fa fa-instagram fa-w-14"
      aria-hidden="true"
      aria-label="Instagram"
      data-prefix="fab"
      data-icon="instagram"
      viewBox="0 0 448 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
      />
    </svg>
  );
};

export const StackedSquaresIcon = ({ ...props }) => {
  return (
    <svg
      className="svg-inline--fa fa-clone fa-w-16 sbi_lightbox_carousel_icon"
      aria-hidden="true"
      aria-label="Clone"
      data-prefix="far"
      data-icon="clone"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 01-6-6V150a6 6 0 016-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 01-6 6zm96-96H150a6 6 0 01-6-6V54a6 6 0 016-6h308a6 6 0 016 6v308a6 6 0 01-6 6z"
      />
    </svg>
  );
};

export const ConsulationIcon = ({ ...props }) => {
  return (
    <svg
      width={170}
      height={166}
      viewBox="0 0 170 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <rect
        x={7.1123}
        y={7.04883}
        width={151}
        height={151}
        rx={75.5}
        fill="#000"
        stroke="#B41B2A"
        strokeWidth={4}
      />
      <path
        transform="translate(.112 .049)"
        fill="url(#pattern0_4_267)"
        d="M0 0H165V165H0z"
      />
      <g filter="url(#filter0_d_4_267)">
        <rect
          x={116.112}
          y={12.0488}
          width={37}
          height={37}
          rx={18.5}
          fill="url(#paint0_linear_4_267)"
        />
      </g>
      <path
        d="M94.932 90.589c-1.68 0-3.103-.56-4.27-1.68-1.166-1.12-1.75-2.497-1.75-4.13s.584-3.033 1.75-4.2c1.167-1.167 2.567-1.75 4.2-1.75 1.634 0 3.034.583 4.2 1.75 1.167 1.167 1.75 2.567 1.75 4.2s-.583 3.01-1.75 4.13c-1.166 1.12-2.543 1.68-4.13 1.68zm0-9.1c-.933 0-1.703.326-2.31.98a3.283 3.283 0 00-.91 2.31c0 .886.304 1.633.91 2.24.607.606 1.354.91 2.24.91.887 0 1.634-.303 2.24-.91.607-.607.91-1.354.91-2.24 0-.887-.303-1.657-.91-2.31-.606-.653-1.33-.98-2.17-.98zm5.6 18.06h-11.34c-.84 0-1.563-.303-2.17-.91-.606-.607-.91-1.33-.91-2.17v-2.94c0-1.493.374-2.894 1.12-4.2l2.24 1.26c-.466.84-.7 1.82-.7 2.94v2.94c0 .093.047.187.14.28.094.093.187.14.28.14h11.34c.094 0 .187-.047.28-.14.094-.093.14-.187.14-.28v-2.94c0-1.213-.326-2.287-.98-3.22l2.24-1.54c.934 1.4 1.4 2.986 1.4 4.76v2.94c0 .84-.303 1.563-.91 2.17-.606.607-1.33.91-2.17.91zm-30.1-8.96c-1.68 0-3.08-.56-4.2-1.68-1.12-1.12-1.68-2.497-1.68-4.13s.56-3.033 1.68-4.2c1.12-1.167 2.497-1.75 4.13-1.75 1.634 0 3.034.583 4.2 1.75 1.167 1.167 1.75 2.567 1.75 4.2s-.583 3.01-1.75 4.13c-1.166 1.12-2.543 1.68-4.13 1.68zm0-9.1c-.933 0-1.703.326-2.31.98a3.283 3.283 0 00-.91 2.31c0 .886.304 1.633.91 2.24.607.606 1.354.91 2.24.91.887 0 1.657-.303 2.31-.91.654-.607.98-1.354.98-2.24 0-.887-.326-1.657-.98-2.31-.653-.653-1.4-.98-2.24-.98zm5.6 18.06h-11.2c-.933 0-1.703-.303-2.31-.91-.606-.607-.91-1.33-.91-2.17v-2.94c0-1.493.374-2.894 1.12-4.2l2.38 1.26c-.56.84-.84 1.82-.84 2.94v2.94c0 .093.047.187.14.28.094.093.234.14.42.14h11.2c.094 0 .187-.047.28-.14.094-.093.14-.187.14-.28v-2.94c0-1.213-.326-2.287-.98-3.22l2.38-1.54c.84 1.4 1.26 2.986 1.26 4.76v2.94c0 .84-.303 1.563-.91 2.17-.606.607-1.33.91-2.17.91zm18.34-26.18l-4.06-3.08h-9.52c-.84 0-1.563-.303-2.17-.91-.606-.607-.91-1.33-.91-2.17v-6.58c0-.84.304-1.563.91-2.17.607-.607 1.33-.91 2.17-.91h12.6c.84 0 1.564.303 2.17.91.607.606.91 1.33.91 2.17v11.62c0 .467-.14.84-.42 1.12-.28.28-.583.397-.91.35-.326-.047-.583-.163-.77-.35zm-13.58-13.16c-.28 0-.42.14-.42.42v6.58c0 .186.14.28.42.28h9.24c.654 0 1.26.233 1.82.7l1.96 1.4v-8.96c0-.093-.046-.187-.14-.28-.093-.093-.186-.14-.28-.14h-12.6zm-12.04 16.38v-11.62c0-.84.304-1.563.91-2.17.607-.607 1.33-.91 2.17-.91h3.64v2.66h-3.64c-.093 0-.186.046-.28.14-.093.093-.14.187-.14.28v8.82l1.82-1.26a2.97 2.97 0 011.96-.7h9.24v2.66h-9.24c-.093 0-.186.046-.28.14l-4.06 2.94c-.093.093-.303.163-.63.21a1.267 1.267 0 01-.91-.21c-.28-.187-.466-.514-.56-.98zm14.42-14h7.84v2.8h-7.84v-2.8z"
        fill="#fff"
      />
      <defs>
        <pattern
          id="pattern0_4_267"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_4_267" transform="scale(.00606)" />
        </pattern>
        <filter
          id="filter0_d_4_267"
          x={100.112}
          y={6.04883}
          width={69}
          height={69}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.819608 0 0 0 0 0.396078 0 0 0 0 0.101961 0 0 0 0.4 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4_267" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_4_267"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4_267"
          x1={121.977}
          y1={8.66309}
          x2={147.248}
          y2={52.4346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1282A" />
          <stop offset={1} stopColor="#D1651A" />
        </linearGradient>
        <image
          id="image0_4_267"
          width={165}
          height={165}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const SelectingVisaCategory = ({ ...props }) => (
  <svg
    width={170}
    height={166}
    viewBox="0 0 170 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect
      x={7.1123}
      y={7.04883}
      width={151}
      height={151}
      rx={75.5}
      fill="#000"
      stroke="#B41B2A"
      strokeWidth={4}
    />
    <path
      transform="translate(.112 .049)"
      fill="url(#pattern0_4_278)"
      d="M0 0H165V165H0z"
    />
    <g filter="url(#filter0_d_4_278)">
      <rect
        x={116.112}
        y={12.0488}
        width={37}
        height={37}
        rx={18.5}
        fill="url(#paint0_linear_4_278)"
      />
    </g>
    <path
      d="M66.48 95.935c-.874-.382-1.488-1.01-1.843-1.883a3.481 3.481 0 01-.04-2.62l4.258-10.234v15.72l-2.375-.983zm34.068-6.468c.382.873.382 1.76 0 2.66-.383.901-1.01 1.543-1.884 1.925l-12.857 5.322a3.71 3.71 0 01-1.31.245c-1.584 0-2.648-.71-3.195-2.129l-8.68-20.959c-.219-.436-.3-.9-.246-1.391 0-1.529.71-2.566 2.13-3.112l12.857-5.321c.436-.164.9-.246 1.392-.246 1.529 0 2.593.71 3.194 2.129l8.599 20.877zM74.628 76.41l.266.266c.178.177.498.266.963.266.464 0 .873-.178 1.228-.532.355-.355.532-.765.532-1.229 0-.463-.177-.873-.532-1.228-.355-.354-.764-.532-1.228-.532-.465 0-.874.178-1.229.532-.355.355-.532.765-.532 1.228 0 .464.177.874.532 1.229zm-2.252 19.69V85.046l5.978 14.573h-2.538c-.928 0-1.734-.341-2.416-1.023-.683-.683-1.024-1.515-1.024-2.497z"
      fill="#fff"
    />
    <defs>
      <pattern
        id="pattern0_4_278"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_4_278" transform="scale(.00606)" />
      </pattern>
      <filter
        id="filter0_d_4_278"
        x={100.112}
        y={6.04883}
        width={69}
        height={69}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.819608 0 0 0 0 0.396078 0 0 0 0 0.101961 0 0 0 0.4 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4_278" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4_278"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4_278"
        x1={121.977}
        y1={8.66309}
        x2={147.248}
        y2={52.4346}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1282A" />
        <stop offset={1} stopColor="#D1651A" />
      </linearGradient>
      <image
        id="image0_4_278"
        width={165}
        height={165}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const PreparingApplication = ({ ...props }) => (
  <svg
    width={170}
    height={166}
    viewBox="0 0 170 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect
      x={7.1123}
      y={7.04883}
      width={151}
      height={151}
      rx={75.5}
      fill="#000"
      stroke="#B41B2A"
      strokeWidth={4}
    />
    <path
      transform="translate(.112 .049)"
      fill="url(#pattern0_4_289)"
      d="M0 0H165V165H0z"
    />
    <g filter="url(#filter0_d_4_289)">
      <rect
        x={116.112}
        y={12.0488}
        width={37}
        height={37}
        rx={18.5}
        fill="url(#paint0_linear_4_289)"
      />
    </g>
    <path
      d="M68.65 72.11v24.48h24.404v3.438H68.649c-.982 0-1.815-.34-2.497-1.023-.683-.682-1.024-1.487-1.024-2.415V72.11h3.521zm27.925-6.959c.983 0 1.816.341 2.498 1.023.683.683 1.024 1.488 1.024 2.416v20.959c0 .982-.341 1.815-1.024 2.497-.682.682-1.515 1.023-2.497 1.023H75.61c-.983 0-1.816-.34-2.498-1.023-.683-.682-1.024-1.515-1.024-2.497v-20.96c0-.927.341-1.732 1.024-2.415.682-.682 1.515-1.023 2.498-1.023h20.965zm-1.72 15.72V77.35H77.33v3.52h17.526zm-7.042 6.959v-3.521H77.33v3.52h10.483zm7.043-14v-3.44H77.33v3.44h17.526z"
      fill="#fff"
    />
    <defs>
      <pattern
        id="pattern0_4_289"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_4_289" transform="scale(.00606)" />
      </pattern>
      <filter
        id="filter0_d_4_289"
        x={100.112}
        y={6.04883}
        width={69}
        height={69}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.819608 0 0 0 0 0.396078 0 0 0 0 0.101961 0 0 0 0.4 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4_289" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4_289"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4_289"
        x1={121.977}
        y1={8.66309}
        x2={147.248}
        y2={52.4346}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1282A" />
        <stop offset={1} stopColor="#D1651A" />
      </linearGradient>
      <image
        id="image0_4_289"
        width={165}
        height={165}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const Submission = ({ ...props }) => (
  <svg
    width={170}
    height={166}
    viewBox="0 0 170 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect
      x={7.1123}
      y={7.04883}
      width={151}
      height={151}
      rx={75.5}
      fill="#000"
      stroke="#B41B2A"
      strokeWidth={4}
    />
    <path
      transform="translate(.112 .049)"
      fill="url(#pattern0_4_298)"
      d="M0 0H165V165H0z"
    />
    <g filter="url(#filter0_d_4_298)">
      <rect
        x={116.112}
        y={12.0488}
        width={37}
        height={37}
        rx={18.5}
        fill="url(#paint0_linear_4_298)"
      />
    </g>
    <path
      d="M82.612 57.549c-3.826 0-7.35.933-10.57 2.8a20.638 20.638 0 00-7.63 7.63c-1.866 3.22-2.8 6.743-2.8 10.57 0 3.826.934 7.35 2.8 10.57a20.637 20.637 0 007.63 7.63c3.22 1.867 6.744 2.8 10.57 2.8 3.827 0 7.35-.934 10.57-2.8a20.634 20.634 0 007.63-7.63c1.867-3.22 2.8-6.743 2.8-10.57s-.933-7.35-2.8-10.57a20.635 20.635 0 00-7.63-7.63c-3.22-1.867-6.743-2.8-10.57-2.8zm11.76 15.54l-13.44 13.3c-.373.373-.84.56-1.4.56-.56 0-1.073-.187-1.54-.56l-7-6.44a2.001 2.001 0 01-.77-1.47c-.046-.607.14-1.12.56-1.54.42-.42.91-.63 1.47-.63.56 0 1.027.187 1.4.56l5.74 5.18 11.9-12.04c.467-.374.98-.56 1.54-.56s1.05.21 1.47.63c.42.42.63.91.63 1.47 0 .56-.186 1.073-.56 1.54z"
      fill="#fff"
    />
    <defs>
      <pattern
        id="pattern0_4_298"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_4_298" transform="scale(.00606)" />
      </pattern>
      <filter
        id="filter0_d_4_298"
        x={100.112}
        y={6.04883}
        width={69}
        height={69}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.819608 0 0 0 0 0.396078 0 0 0 0 0.101961 0 0 0 0.4 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4_298" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_4_298"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4_298"
        x1={121.977}
        y1={8.66309}
        x2={147.248}
        y2={52.4346}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1282A" />
        <stop offset={1} stopColor="#D1651A" />
      </linearGradient>
      <image
        id="image0_4_298"
        width={165}
        height={165}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const DrawerConsulationIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_224_6130)">
        <mask
          id="a"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={41}
          height={41}
        >
          <path d="M.613.55h40v40h-40v-40z" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path
            d="M20.613 40.55c11.046 0 20-8.953 20-20 0-11.045-8.954-20-20-20s-20 8.955-20 20c0 11.047 8.954 20 20 20z"
            fill="#E0F4FF"
          />
          <mask
            id="b"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x={7}
            y={7}
            width={27}
            height={27}
          >
            <path d="M7.613 7.55h26v26h-26v-26z" fill="#fff" />
          </mask>
          <g mask="url(#b)">
            <path
              d="M25.434 24.406c-.842.732-1.89 1.643-3.796 1.643h-1.14c-1.377 0-2.631-.491-3.528-1.382-.876-.87-1.36-2.061-1.36-3.354v-1.529c0-1.293.483-2.484 1.36-3.355.897-.891 2.15-1.382 3.529-1.382h1.139c1.907 0 2.954.911 3.796 1.643.873.759 1.627 1.415 3.635 1.415.306 0 .613-.024.916-.072l-.007-.017a6.74 6.74 0 00-.423-.851l-1.344-2.282c-1.232-2.094-3.51-3.383-5.974-3.383H19.55c-2.464 0-4.742 1.29-5.974 3.383l-1.344 2.282a6.655 6.655 0 000 6.767l1.344 2.282c1.232 2.094 3.51 3.383 5.974 3.383h2.686c2.464 0 4.742-1.29 5.974-3.383l1.344-2.282a6.74 6.74 0 00.423-.851l.007-.018a5.859 5.859 0 00-.916-.071c-2.008 0-2.762.655-3.635 1.415v-.001zm-3.796-7.974h-1.14c-2.096 0-3.475 1.47-3.475 3.351v1.529c0 1.881 1.378 3.351 3.476 3.351h1.139c3.056 0 2.817-3.057 7.432-3.057.437 0 .874.039 1.305.117.14-.777.14-1.574 0-2.351-.43.078-.867.117-1.305.117-4.615-.001-4.375-3.058-7.431-3.058l-.001.001z"
              fill="#006BFF"
            />
            <path
              d="M33.025 22.839a6.495 6.495 0 00-2.65-1.117l-.005.023a6.647 6.647 0 01-.386 1.317 5.11 5.11 0 012.192.885l-.006.02a11.483 11.483 0 01-1.646 3.279 11.88 11.88 0 01-9.665 4.908 11.96 11.96 0 01-4.606-.911 11.81 11.81 0 01-3.762-2.488 11.549 11.549 0 01-2.536-3.69 11.35 11.35 0 01-.93-4.518 11.35 11.35 0 01.93-4.518 11.56 11.56 0 012.536-3.69 11.81 11.81 0 013.762-2.488 11.96 11.96 0 014.606-.911 11.88 11.88 0 019.665 4.908 11.457 11.457 0 011.652 3.299 5.098 5.098 0 01-2.192.885c.174.424.304.866.386 1.318l.004.02a6.495 6.495 0 002.651-1.116c.756-.55.61-1.168.495-1.536-1.667-5.31-6.705-9.167-12.66-9.167-7.317 0-13.247 5.818-13.247 12.994s5.93 12.994 13.246 12.994c5.957 0 10.995-3.858 12.661-9.165.115-.365.262-.986-.495-1.535z"
              fill="#006BFF"
            />
            <path
              d="M29.983 18.03a5.868 5.868 0 01-.916.072c-2.008 0-2.762-.656-3.635-1.415-.842-.732-1.889-1.642-3.796-1.642h-1.139c-1.378 0-2.632.49-3.529 1.382-.876.87-1.359 2.06-1.359 3.354v1.529c0 1.293.482 2.484 1.36 3.355.896.89 2.15 1.382 3.528 1.382h1.14c1.906 0 2.953-.911 3.795-1.642.873-.76 1.627-1.415 3.635-1.415.307 0 .613.024.916.07.174-.423.303-.865.385-1.316l.004-.023a7.303 7.303 0 00-1.305-.117c-4.615 0-4.375 3.057-7.43 3.057h-1.14c-2.097 0-3.476-1.47-3.476-3.351v-1.53c0-1.88 1.38-3.35 3.477-3.35h1.14c3.055 0 2.815 3.057 7.43 3.057.438 0 .875-.039 1.305-.117l-.004-.021a6.583 6.583 0 00-.386-1.317v-.002z"
              fill="#0AE8F0"
            />
            <path
              d="M29.983 18.03a5.868 5.868 0 01-.916.072c-2.008 0-2.762-.656-3.635-1.415-.842-.732-1.889-1.642-3.796-1.642h-1.139c-1.378 0-2.632.49-3.529 1.382-.876.87-1.359 2.06-1.359 3.354v1.529c0 1.293.482 2.484 1.36 3.355.896.89 2.15 1.382 3.528 1.382h1.14c1.906 0 2.953-.911 3.795-1.642.873-.76 1.627-1.415 3.635-1.415.307 0 .613.024.916.07.174-.423.303-.865.385-1.316l.004-.023a7.303 7.303 0 00-1.305-.117c-4.615 0-4.375 3.057-7.43 3.057h-1.14c-2.097 0-3.476-1.47-3.476-3.351v-1.53c0-1.88 1.38-3.35 3.477-3.35h1.14c3.055 0 2.815 3.057 7.43 3.057.438 0 .875-.039 1.305-.117l-.004-.021a6.583 6.583 0 00-.386-1.317v-.002z"
              fill="#0AE8F0"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_224_6130">
          <path fill="#fff" transform="translate(.613 .55)" d="M0 0H40V40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DrawerNoteBook = ({ ...props }) => {
  return (
    <svg
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <rect
        x={0.613281}
        y={0.550781}
        width={40}
        height={40}
        rx={20}
        fill="url(#pattern0_224_6171)"
      />
      <defs>
        <pattern
          id="pattern0_224_6171"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_224_6171" transform="scale(.02273)" />
        </pattern>
        <image
          id="image0_224_6171"
          width={44}
          height={44}
          preserveAspectRatio="none"
          xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAsACwDASIAAhEBAxEB/8QAHAAAAgIDAQEAAAAAAAAAAAAABggEAwcAAQUJ/8QAOBAAAQMDAwEEBQoHAAAAAAAAAQIDBAURBgAHIRIxIlEUYXEIExUyFiNBY3OxwdEXQlRXkZKTlf/EABgBAQEBAQEAAAAAAAAAAAAAAAUEAwEC/8QAHxEAAgICAgMBAAAAAAAAAAAAAQIAAxEEIRMiMUES/9oADAMBAAIRAxEAPwD6iSYlOiMqcdix0pH2SefR2aHJk5p5RDMSOyj7pJV+Grq7OMqYpAP0bZ6QPT9Z0ue4m4u4uSbzObdbcro1I+G0xupVSsVlpb1veKshtpCTybcknxPIt3laddQv6YZMWo11ChmGTM89Kb36E/4jU2HOaZUA9EjvI+6SFfhpevmf7Q/9QsR/4q/113AdxNwsX3ki7ebiPUes/Fqa5UaZWKOytjvNqs404gm3ZyCPR237tLVowwRK2qRhgiNPGiU6WylxqLHUk/ZJ49HZq34XC/lGP9Sf00O0KcYsxKCfo3D0ken6jos0RdX1Nj5BbqupsfIBqUVKJPaTc6V6sRTN9ozeRgQKhVS5h8NPkqTI8vKeuVd1tzqHSo+N/wC/YWqqkUw5zqLWST1J9R0oe5NexvBfaVy5rP5srHsbzDGY8OJVmVONoK21kONh1AuhYHPqtf5Qu0pDAERxSGAIgxhmzsPJsmg0yft1ulQIchRS5UpmS3aYAST1K797cW4557Doqa3d20xrcTGnoNHyWu07FVfNdGZh0yILD0gpHu1uKVd0gixUBxfi4KdC26szHtsWcXwKjZzOx7AsyjuVmq5LMnuzJDsRKE9LEZRv0e9SRyBzcdouFGmz22P7tOY/XZ1FVjG1OPqS7ieJKT0qmLHKahLH8RJupKTe9yTcElfZ6jSpUUqBHaDcaPNBlLimZOaRa6QepXqGjPRu2RkCF7hGQJCqdNRUWbHuuJ+Sr8vVoLrmOMTGvLVSnsTGOrqCJDSXEE+IBBF9ZB1xSQoWIuPA6xqvavj2JhTsNVx7ExhPxmkVRthubSoMxuOnpZRIjIWGxxwkEcDgdnhr2IdPdldLbDXdHHAslI0Y+RjXv5dq/j0DVyUhIsBYeA1u23x4iUtuceIkOmU1FOZsO84r5Svy9Wput1uoGYscmHMxY5M//9k="
        />
      </defs>
    </svg>
  );
};

export const FillCallIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    {...props}
  >
    <path
      d="M19.885 15.16c.338.34.507.769.507 1.289 0 .52-.169.989-.507 1.405l-1.874 1.874c-1.014.989-2.673 1.008-4.976.058s-4.639-2.595-7.007-4.937C3.712 12.533 2.08 10.21 1.13 7.88c-.95-2.329-.943-3.988.02-4.977L3.062.992C3.4.653 3.829.484 4.35.484c.52 0 .989.17 1.405.508l2.771 2.81c.495.495.664 1.08.508 1.757-.156.676-.56 1.119-1.21 1.327a1.897 1.897 0 00-1.035.878c-.247.43-.293.865-.136 1.308.234 1.04.904 2.101 2.01 3.18 1.106 1.08 2.153 1.75 3.142 2.011.468.104.917.04 1.347-.195.43-.234.722-.572.878-1.015.182-.65.612-1.054 1.288-1.21.677-.156 1.275.013 1.796.508l2.771 2.81z"
      fill="currentColor"
    />
  </svg>
);

export const GLOcationIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={22}
    viewBox="0 0 20 22"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_172_8201)">
      <path
        d="M11.623 2.44l.634-.644c.423-.43 1.235-.645 2.435-.645s2.23.43 3.089 1.29c.859.859 1.288 1.89 1.288 3.09 0 .6-.361 1.521-1.084 2.763a143.614 143.614 0 00-2.127 3.787c-.696 1.282-1.003 2.306-.92 3.07 0 .136-.076.204-.226.204-.15 0-.225-.068-.225-.204.055-.764-.259-1.788-.94-3.07a112.453 112.453 0 00-2.108-3.787c-.723-1.242-1.084-2.163-1.084-2.763 0-1.2.423-2.231 1.268-3.09zm4.317 1.842l-.256-.255c-.17-.171-.494-.256-.972-.256-.477 0-.886.17-1.227.511a1.7 1.7 0 00-.512 1.249c0 .491.17.907.512 1.249.34.34.75.511 1.227.511.478 0 .887-.17 1.228-.511a1.7 1.7 0 00.511-1.249 1.7 1.7 0 00-.511-1.249zM2.5 2.912h7.569a5.235 5.235 0 00-.819 2.824c0 .71.437 1.842 1.31 3.397L.78 18.917l-.04-.287V4.671c0-.49.17-.907.51-1.248A1.697 1.697 0 012.5 2.91zm10.923 11.256l-2.086-2.087.573-.614c.654 1.064 1.159 1.965 1.513 2.701zm2.496 6.223H3.031l6.424-6.468 6.464 6.468zm2.291-10.152v8.391l-.04.287-2.946-2.947c.081-.246.177-.498.286-.758a20.533 20.533 0 011.248-2.477c.204-.354.354-.62.45-.798.095-.177.266-.47.511-.88l.491-.818zm-13.378.982c-.464 0-.832-.095-1.105-.287a.901.901 0 01-.41-.777c0-.382.246-.669.737-.86.273-.082.573-.123.9-.123h.205c.354.273.6.478.736.614a.67.67 0 01.205.492c0 .245-.123.463-.368.655-.246.19-.546.286-.9.286zM3.809 6.227c0-.273.075-.485.225-.635.15-.15.32-.225.511-.225.355 0 .634.164.839.491.204.328.307.67.307 1.024 0 .3-.089.512-.266.634a.957.957 0 01-.553.185c-.3 0-.552-.157-.756-.471a1.805 1.805 0 01-.307-1.003zm2.127 2.538l-.286-.246c-.164-.136-.246-.259-.246-.368 0-.191.096-.355.287-.491.463-.355.695-.75.695-1.188 0-.382-.19-.736-.572-1.064h.49l.369-.368h-1.76c-.572 0-1.016.157-1.33.47-.313.314-.47.69-.47 1.126 0 .355.123.669.368.942.246.273.587.41 1.023.41h.205l-.082.327c0 .19.082.382.245.573-.654.027-1.2.177-1.636.45-.436.246-.655.587-.655 1.023 0 .355.157.648.47.88.315.232.771.348 1.371.348.682 0 1.221-.163 1.617-.49.395-.328.593-.697.593-1.106 0-.437-.232-.846-.696-1.228z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_8201">
        <path
          fill="#fff"
          transform="matrix(1 0 0 -1 .72 21.25)"
          d="M0 0H18.37V21H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const FillMailIcon = ({ ...props }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.169 8.75l4.293 4.321a1.29 1.29 0 01-.53.112H2.168a1.29 1.29 0 01-.53-.112L5.931 8.75 7.13 9.948c.26.26.571.386.934.377.362-.01.664-.135.906-.377l1.199-1.198zm3.764-5.605c.185 0 .362.038.53.112l-4.601 4.6-1.478 1.506a.519.519 0 01-.334.111.519.519 0 01-.335-.111L6.237 7.857l-4.6-4.6a1.29 1.29 0 01.53-.112h11.766zm-12.881.697l4.293 4.322-4.293 4.322a1.238 1.238 0 01-.14-.558V4.4c0-.186.047-.372.14-.558zm13.996 0c.093.186.14.372.14.558v7.528c0 .186-.047.372-.14.558l-4.294-4.322 4.294-4.322z"
      fill="currentColor"
    />
  </svg>
);

export const FillLocationIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={15}
    viewBox="0 0 11 15"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_172_11247)">
      <path
        d="M1.478 2.458c.984-.993 2.178-1.49 3.581-1.49 1.404 0 2.598.497 3.582 1.49.985.994 1.478 2.184 1.478 3.57 0 .656-.16 1.403-.48 2.242-.32.839-.684 1.6-1.093 2.283-.41.683-.88 1.385-1.408 2.106-.529.72-.912 1.216-1.15 1.49-.236.273-.437.492-.6.656a.418.418 0 01-.329.164.418.418 0 01-.328-.164 17.706 17.706 0 01-.875-1.04 66.23 66.23 0 01-1.53-2.05 14.92 14.92 0 01-1.669-2.94C.22 7.746 0 6.83 0 6.029c0-1.386.493-2.576 1.478-3.57zm3.581 6.139c.71 0 1.312-.25 1.805-.75a2.484 2.484 0 00.739-1.805c0-.703-.247-1.305-.74-1.807a2.436 2.436 0 00-1.804-.75c-.71 0-1.311.25-1.804.75a2.47 2.47 0 00-.739 1.793 2.54 2.54 0 001.272 2.229c.391.226.815.34 1.271.34z"
        fill="#B41B2A"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_11247">
        <path
          fill="#fff"
          transform="translate(0 .969)"
          d="M0 0H10.1172V14H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
